export const SUBSCRIPTION_SETTINGS_PAGES = {
    SUBSCRIPTION_PAYMENT: "subscription_payment",
    SUBSCRIPTION_SELECTION: "subscription_selection",
    SUBSCRIPTION_INFO: "subscription_info"
}

export const SUBSCRIPTION_SETTINGS_ACTIONS = {
    SUBSCRIBING: "subscribing",
    CHANGING: "changing",
    CANCELING: "canceling",
    VIEWING: "viewing"
}